module.exports = __webpack_public_path__ + "img/rocket.5af0d844.png";